import { motion } from "framer-motion";

/**
 * Scroll-triggered fade + translate reveal wrapper.
 * Wrap any block to animate-in once it scrolls into view.
 */
export const Reveal = ({ children, delay = 0, y = 24, className = "", as: As = "div" }) => {
  const MotionTag = motion[As] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
